import React, {useState} from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import {CheckMark} from '../icons';

const SuccessSnackbar: React.FC<{title: string; subtitle: string}> = ({title, subtitle}) => {
    const [open, setOpen] = useState(true);

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
            sx={{
                '&.MuiSnackbar-anchorOriginTopCenter': {transform: {xs: 'translateX(-50%)'}},
                maxWidth: 408,
                width: '100%',
                top: {xs: 14},
                left: {xs: '50%'},
            }}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert
                onClose={handleClose}
                severity="success"
                sx={{
                    width: '100%',
                    backgroundColor: '#ffffff',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                    borderRadius: '2px',
                    padding: '0 16px 0 0',
                    fontFamily: 'FredokaRegular',
                    fontSize: 15,
                    color: '#5A5A5A',
                    '& .MuiSvgIcon-root': {fontSize: '2rem'},
                    '& .MuiAlert-icon': {backgroundColor: '#DFFFD9', padding: '26px 12px'},
                    '& .MuiAlert-message': {padding: '16px 0', fontSize: 15, color: '#5A5A5A', alignSelf: 'center'},
                }}
                iconMapping={{
                    success: <CheckMark />,
                }}
            >
                <AlertTitle sx={{fontFamily: 'FredokaMedium', fontSize: 18, color: '#333333', marginBottom: 0}}>
                    {title}
                </AlertTitle>
                {subtitle}
            </Alert>
        </Snackbar>
    );
};

export default SuccessSnackbar;
